export const MOCK_QUOTE_RESPONSE = {
  quoteId: 'COT-2024-001234',
  vehicleData: {
    brand: 'Toyota',
    brandId: 'toyota',
    model: 'Corolla',
    modelId: 'corolla',
    year: 2022,
    licensePlate: 'ABC123',
    use: 'particular',
    city: 'Bogotá D.C.',
    cityId: 'bogota',
    value: 85000000,
  },
  driverData: {
    firstName: 'Carlos',
    lastName: 'Rodríguez',
    documentType: 'RUT',
    documentNumber: '12345678-9',
    birthDate: '1985-06-15',
    gender: 'M',
    email: 'carlos.rodriguez@email.com',
    phone: '3001234567',
    licenseYear: 2005,
  },
  plans: [],
  validUntil: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
  generatedAt: new Date().toISOString(),
};
